<template>
  <div class="content">
    <div class="card">
      <div class="card-header bg-white header-elements-inline">
        <div class="card-title">
          <h5 class="font-weight-semibold">
            <i class="fa-solid fa-users-medical mr-2" />{{ $t('Refer Friends') }}
          </h5>
          <div>{{ $t('Invite friends to register and get special privileges.') }}</div>
        </div>
      </div>
      <div class="card-body">
        <div v-show="onload">
          <placeholder-content is-load="true" />
        </div>
        <div 
          v-show="!onload" 
          :class="['card', loading]"
        >
          <div
            v-if="user.reference_url !=''"
            class="card card-body p-0"
          >
            <div class="p-3 pb-0">
              <div class="input-group">
                <input
                  id="referenceUrl"
                  type="text"
                  class="form-control border-right-0 bg-white"
                  :value="user.reference_url"
                  readonly
                  v-clipboard:copy="onCopyMessage"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                <span class="input-group-append">
                  <button
                    type="button"
                    class="btn bg-primary"
                    v-clipboard:copy="onCopyMessage"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  ><i class="fas fa-copy mr-2" />{{ $t('Copy link') }}</button>
                </span>
              </div>
            </div>
            <div class="btn-group flex-wrap w-100 pb-3 px-3">
              <div class="dataTables_length ml-auto mb-0">
                <PerPage @per-page="setPerPage" />
              </div>
            </div>
            <div class="table-responsive mt-0 data-nowrap">
              <vuetable
                class="border-top"
                ref="vuetable" 
                :no-data-template="$t('No Data Available')" 
                :fields="fields" 
                data-path="data" 
                pagination-path="" 
                :data-manager="dataManager"
                :api-mode="false" 
                @vuetable:pagination-data="onPaginationData"
              >
                <template
                  slot="friend"
                  slot-scope="props"
                >
                  {{ props.rowData.friend_user.first_name }}
                </template>
                <template
                  slot="plan"
                  slot-scope="props"
                >
                  <span
                    v-if="props.rowData.reward"
                    class="badge badge-blue"
                  >{{ $t(props.rowData.reward.plan.name) }}</span>
                  <span
                    v-else
                    class="badge badge-warning"
                  >{{ $t('Pending') }}</span>
                </template>
                <template
                  slot="reward"
                  slot-scope="props"
                >
                  <span v-if="props.rowData.reward">{{ props.rowData.reward.name == 'None Reward' ? '-' : props.rowData.reward.name }}</span>
                  <span v-else>-</span>
                </template>
                <template
                  slot="tenant"
                  slot-scope="props"
                >
                  <span v-if="props.rowData.tenant">{{ props.rowData.tenant.name }}</span>
                  <span v-else>-</span>
                </template>
                <template
                  slot="created_date"
                  slot-scope="props"
                >
                  <span>{{ convertTimezone(props.rowData.created_date) }}</span>
                </template>
              </vuetable>
            </div>
            <div class="datatable-footer">
              <vuetable-pagination-info
                class="dataTables_info"
                ref="paginationInfo"
                :no-data-template="$t('No relevant data')"
                :info-template="$t('Displaying {from} to {to} of {total} items')"
              />
              <div class="dataTables_paginate paging_simple_numbers mb-0">
                <vuetable-pagination
                  class="ml-auto"
                  ref="pagination"
                  @vuetable-pagination:change-page="onChangePage"
                />
              </div>
            </div>
          </div>
          <div
            v-else
            class="card-body p-0 bg-white header-elements-inline"
          >
            <div class="form-group pl-lg-4 col text-center">
              <div class="form-control-plaintext">
                <button
                  class="btn btn-primary"
                  @click="createLinkrefer"
                >
                  <i class="fa-regular fa-plus mr-1" /> {{ $t('Be refferal') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
//components
import Api from '@/services/endpoint/central.service'
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination"
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import PerPage from "./PerPage.vue";

export default {
    name: 'ReferFriendsIndex',
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        PlaceholderContent,
        PerPage,
    },
    data() {
        return {
            totalFriends: 0,
            onload: true,
            user: Object,
            vuetableFields: false,
            fields: [
                {
                    name: 'friend',
                    title: this.$t('Friends'),
                    filterable: false,
                    togglable: false,
                    width: '200px'
                },
                {
                    name: 'plan',
                    title: this.$t('Plan'),
                    filterable: false,
                    togglable: false,
                    width: '200px'
                },
                {
                    name: 'reward',
                    title: this.$t('Reward'),
                    filterable: false,
                    togglable: false,
                },
                {
                    name: 'tenant',
                    title: this.$t('Store'),
                    filterable: false,
                    togglable: false,
                },
                {
                    name: 'created_date',
                    title: this.$t('Created Date'),
                    filterable: false,
                    togglable: false,
                    width: '180px'
                },
            ],
            paramsQuery: {
                per_page: 10,
                page: 1,
            },
            loading: '',
        }
    },
    mounted() {
        this.getReferFriends();
    },
    methods: {
        async createLinkrefer(){
                this.loading = true;
                let params = {email: this.user.email, userId: this.user.global_id};
                let data = await Api.Auth.createReferLink(params);
                let respones = data.data.status;
                if(respones === true){
                    this.loading = false;
                    this.$toastr.s(this.$t("Create refer link success."), "<span class='t-icon icon-checkmark3'></span>" + this.$t("Success"));
                    this.onload = true;
                    this.totalFriends= 0;
                    this.user=Object;
                    this.vuetableFields = false;
                    this.getReferFriends();
                }else{
                    this.loading = false;
                    this.$toastr.e(this.$t('Create refer link failed. Please try again.'),"<span class='icon-blocked'></span>"+this.$t('Error'));
                    this.onload = true;
                    this.totalFriends= 0;
                    this.user=Object;
                    this.vuetableFields = false;
                    this.getReferFriends();
                }
        },
        setPerPage(perPage) {
            this.paramsQuery.per_page = perPage;
            this.paramsQuery.page = 1;
            this.$refs.vuetable.currentPage = 1;
            this.getReferFriends();
        },
        convertTimezone(date){
            return convertTimezone.utcToLocal(date);
        },
        dataManager(sortOrder, pagination) {
            this.getReferFriends();
        },
        async getReferFriends() {
            this.loading = "loading";

            let queryString = "";
            if (this.paramsQuery) {
              this.paramsQuery.page = this.$refs.vuetable.currentPage;
              queryString += "?" + $.param(this.paramsQuery);
            }
            let data = this.$storeIndex.mutations.vueTableFormatJson(await Api.Auth.getReferFriends(queryString));
            this.$refs.vuetable.setData(data);
            this.totalFriends = data.total
            this.getUser();
            this.loading = "";
        },
        async getUser() {
            let data = await Api.Auth.User();
            this.user = data.data
            this.onload = false
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        onChangePage(page) {
          // this.paramsQuery.page = page;
          this.$refs.vuetable.changePage(page);
        },
        onCopy: function (e) {
            this.$toastr.s(this.$t("Copy link success"), "<span class='t-icon icon-checkmark3'></span>" + this.$t("Success"));
        },
        onError: function (e) {
            this.$toastr.e(this.$t("Copy link failed"), "<span class='t-icon icon-blocked'></span>" + this.$t("Success"));
        },
        onCopyMessage() {
            return $('#referenceUrl').val()
        }
    }
}
</script>
<style scoped>
    .datatable-header, .datatable-footer {
        padding: 1.25rem 1.25rem 0 1.25rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/central/account/referfriends/ReferFriendsIndex.vue